import React, { useEffect, useState } from 'react';

import heroImg1 from '../images/mint_air_association.png';
import heroImg from '../images/homepage.png';
import noir1 from '../images/noir2.jpeg';
import noir2 from '../images/acvent_grp2.jpeg';

const Hero = () => {
  const slides = [heroImg1, heroImg, noir1, noir2];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const slideTimer = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 10000);

    return () => clearInterval(slideTimer);
  }, [slides.length]);

  return (
    <>
      <div className="hero relative overflow-hidden h-screen" id="hero">
        {/* Background slide */}
        <img
          src={slides[activeSlide]}
          alt="hero slide"
          className="absolute inset-0 w-full h-full object-cover object-center transition-all duration-1000 z-0"
        />

        {/* Image controls (dots) */}
        <div className="absolute bottom-6 left-0 right-0 z-30 flex justify-center">
          <div className="flex items-center gap-2 rounded-full bg-black/35 px-3 py-2">
            {slides.map((_, index) => (
              <button
                key={index}
                type="button"
                aria-label={`Change hero image ${index + 1}`}
                onClick={() => setActiveSlide(index)}
                className={`h-2.5 w-2.5 rounded-full transition-all duration-200 ${
                  index === activeSlide
                    ? 'bg-amber-500 scale-125'
                    : 'bg-white/60 hover:bg-white/80'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Readability overlay (keeps text readable, doesn't hide image) */}
        <div className="absolute inset-0 bg-black/40 z-10" />

        {/* Foreground content */}
        <div className="relative z-20">
          <div
            className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 min-h-[80vh] flex items-center"
            data-aos="zoom-in"
          >
            <div className="w-full flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left">
              <div
                className="lg:w-1/2 flex flex-col justify-center"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div className="p-0 md:p-0">
                  <h1 className="mb-4 md:text-2xl text-3xl font-extrabold tracking-wide text-white drop-shadow-[0_2px_10px_rgba(0,0,0,0.85)] [text-shadow:_0_2px_8px_rgba(0,0,0,0.8)]">
                    In association with <span className="text-amber-500">Mint Air</span>
                  </h1>

                  {/* <div
                    className="text-xl font-semibold tracking-tight"
                    style={{ color: 'rgba(246, 242, 234, 0.86)' }}
                  >
                    Delivering only the best products for you!
                  </div> */}
                </div>
              </div>

              <div className="mt-6 lg:mt-0 lg:w-1/2" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hero;

